// Mirrors backend MASTER_DEFS. Each master has a display label and optional extra
// fields ([key, label]) that are collected in the inline "+ Add New" form and can
// be auto-filled into linked record fields on selection.
export const MASTER_DEFS = {
  destination:   { label: "Destination", fields: [] },
  specification: { label: "Product Specification", fields: [] },
  body_no:       { label: "Body Number", fields: [] },
  serial_no:     { label: "Serial Number", fields: [] },
  key_no:        { label: "Key Number", fields: [] },
  key_embossing: { label: "Key Embossing", fields: [] },
  m_key_no:      { label: "M. Key Number", fields: [] },
  extra_lock:    { label: "Extra Lock", fields: [] },
  extra_part:    { label: "Extra Parts", fields: [] },
  packing:       { label: "Packing", fields: [] },
  vehicle:       { label: "Vehicle", fields: [] },
  gate_pass:     { label: "Gate Pass", fields: [] },
  transporter:   { label: "Transporter", fields: [["contact", "Contact Number"], ["address", "Address"], ["location", "Location"]] },
  godown:        { label: "Godown", fields: [["address", "Godown Address"], ["contactNo", "Contact No."], ["contactPerson", "Contact Person"]] },
  lr:            { label: "LR Number", fields: [] },
  installer:     { label: "Installer", fields: [["gst", "GST / Service Tax No."], ["contact", "Contact Number"], ["address", "Address"]] },
  pickup_person: { label: "Pickup Person", fields: [["aadhaarNo", "Aadhaar No."]] },
  eway_bill:     { label: "E-way Bill", fields: [] },
  site_status:   { label: "Site Status", fields: [] },
  designation:   { label: "Designation", fields: [] },
  special_info:  { label: "Special Information", fields: [] },
  distance:      { label: "Route / Distance", fields: [["distanceKm", "Distance (km)"]] },
  packet_no:     { label: "Packet Number", fields: [] },
  local_rent:    { label: "Local Rent", fields: [] },
};

// Ordered groups for the Master Data hub page.
export const MASTER_GROUPS = [
  { title: "Sales & Sites", types: ["destination", "site_status", "designation"] },
  { title: "Product / Item", types: ["specification", "body_no", "serial_no", "key_no", "key_embossing", "m_key_no", "extra_lock", "extra_part", "packing", "special_info"] },
  { title: "Dispatch", types: ["vehicle", "gate_pass", "packet_no", "local_rent"] },
  { title: "Transport & Logistics", types: ["transporter", "godown", "lr"] },
  { title: "Installation", types: ["installer", "pickup_person", "eway_bill", "distance"] },
];
